import styled from "styled-components";
import { ProgramBrowserContainer } from "../ProgramBrowser/styles";

export const UserBrowserContainer = styled(ProgramBrowserContainer)``;